export const UnPin = (props: any) => <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.00001 10L8.00001 14M8.00001 14L12 10M8.00001 14L8.00001 4.66667M12.6667 2L3.33334 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>
